import React, { useContext } from "react";
import { SlidersContext } from "../providers/SlidersProvider";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import WarningIcon from "@mui/icons-material/Warning";
import PhoneIcon from "@mui/icons-material/Phone";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { colourScheme, statusMap } from "../popData";
import HowToReg from "@mui/icons-material/HowToReg";
import EngineeringIcon from "@mui/icons-material/Engineering";

import { dateTimeFormatter } from "../helperFunctions/dateFormatters";

function PrimaryCard({
  ts,
  editPrimary,
  marked,
  primarySectionType,
  // inEditMode,
  // markItem,
}) {
  const { sliderId } = useContext(SlidersContext);

  let {
    refNumber,
    uid,
    primaryType,
    name = "",
    jobDetails = "",
    status = "",
    authorisedBy = "",
    email = "",
    address = "",
    postcode = "",
    number = "",
    address2 = "",
    jobReceived = "- / -",
    bookedInDateTime = "",
    jobDayOrderNumber = "",

    // callLog = [],
    worksOrderNumber = "",
    paid = false,
    sent = false,
    cert = false,
    subcontractorPaid = false,
    subcontracted = false,
  } = ts;

  // Is primary currently selected?
  // let isSelected =
  //   uid === window.sessionStorage.getItem("currentPrimary");
  let isSelected = uid === sliderId;

  //In Restores, need a prefix to tell which kind primary type is: timesheet or quote
  let primaryPrefix = "";
  if (primarySectionType === "restore") {
    primaryPrefix = `${primaryType[0].toUpperCase()} - `;
  }

  //If Private customer, show authorisedBy name on card.
  //If known customer, show customers name
  let nameOnCard = name === "Private" && authorisedBy ? authorisedBy : name;

  // let marked = isMarked(uid);

  // More info bar setup >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
  let needInfo = false;
  let warnings = [];

  if (!address || !postcode || !number || !email) {
    needInfo = true;
    if (!address || !postcode) {
      warnings.push({
        label: "address",
        key: "address",
        icon: (
          <p key="address" className="more-info-icon">
            A
          </p>
        ),
      });
    }

    if (!email) {
      warnings.push({
        label: "email",
        key: "email",
        icon: <MailOutlineIcon key="email" className="more-info-icon" />,
      });
    }

    if (!number) {
      warnings.push({
        label: "number",
        key: "number",
        icon: <PhoneIcon key="number" className="more-info-icon" />,
      });
    }
  }
  return (
    <React.Fragment key={uid}>
      {needInfo && primarySectionType === "jobsheet" && (
        <div className="need-more-info-bar">
          <WarningIcon className="warning-icons" />
          {warnings.map((w, i) => {
            return w.icon;
          })}
        </div>
      )}
      <div tabIndex="0" className="primaryCard" onClick={() => editPrimary(ts)}>
        {bookedInDateTime &&
          (status === "booked-in" || status === "in-progress" || status === "provisional") && (
            <div className="booked-in-time">
              <>
                <p>{`${dateTimeFormatter(bookedInDateTime, "d_day_short")} - ${dateTimeFormatter(
                  bookedInDateTime,
                  "t_short"
                )}`}</p>
                {/* <p className="jobDayOrderNumber">{jobDayOrderNumber}</p> */}
              </>
            </div>
          )}
        {/* <div className="callLogIndicator">
              <div className="callLog">
                {logStatus &&
                  callLog.map((cl, i) => {
                    return (
                      <p key={i}>
                        {cl?.icon} - {cl?.time}
                      </p>
                    );
                  })}
              </div>
            </div> */}
        <div
          style={isSelected ? { backgroundColor: "var(--black)" } : {}}
          className={`cardHeader ${primaryType} ${ts?.subcontracted && "subcontracted"}`}
        >
          <span>
            {primaryPrefix}
            {refNumber}
            {subcontracted && (
              <EngineeringIcon style={{ fontSize: 16, marginLeft: "8px", color: `white` }} />
            )}
          </span>
          <span>{worksOrderNumber}</span>
          {/* {primarySectionType === "jobsheet" && ( */}
          <span>
            {statusMap[status]?.name}{" "}
            <span className="jobOrderNumber">{jobDayOrderNumber ? ` (${jobDayOrderNumber})` : ""}</span>
          </span>
          {/* )} */}

          {status === "booked-in" ||
          status === "completed" ||
          status === "provisional" ||
          status === "in-progress" ? (
            <span className="cardDate" style={{ color: "black" }}>
              {bookedInDateTime ? dateTimeFormatter(bookedInDateTime, "d_short") : "---- / ----"}
            </span>
          ) : (
            <span className="cardDate" style={{ color: colourScheme[status]?.color }}>
              {dateTimeFormatter(jobReceived, "d_short")}
            </span>
          )}

          {/* {primarySectionType === "jobsheet" && ( */}
          <p style={{ ...colourScheme[status] }} className="statusColourBlock"></p>
          {/* )} */}
        </div>
        <div className="cardBody">{jobDetails}</div>
        <div className="cardFooter">
          <div>
            <p>{nameOnCard}</p>
          </div>
          <div>
            <p>{address}</p>
            <p>{address2}</p>
          </div>
        </div>
        {paid && <div className="paidBar" />}

        <div className="cardMarkers">
          {subcontractorPaid && (
            <div className="subBar">
              <HowToReg style={{ fontSize: 22 }} />
            </div>
          )}

          {cert && (
            <div className="certBar">
              <CopyrightIcon style={{ fontSize: 22 }} />
            </div>
          )}

          {sent && (
            <div className="sentBar">
              <DoubleArrowIcon style={{ fontSize: 22 }} />
            </div>
          )}
        </div>
        {marked && <div className="markedPrimary" />}
      </div>
    </React.Fragment>
  );
}

export default React.memo(PrimaryCard);
